/**
 * TrendSetter wash menu - structured for staff selection and customer-facing price list.
 * Edit `washPackages` below to match the client’s official price sheet (replace any placeholder rows).
 * Each package has vehicle tiers with ZAR prices.
 */

export const washPackages = [
  {
    id: 'wash-go',
    name: 'Wash & Go',
    description: 'Exterior wash',
    tiers: [
      { id: 'car', label: 'Cars', price: 50 },
      { id: 'suv', label: 'SUV / D-Cabs', price: 50 },
      { id: 'kombi', label: 'Kombi', price: 60 },
    ],
  },
  {
    id: 'wash-vac',
    name: 'Wash & Vac',
    description: 'Exterior wash and interior vacuum',
    tiers: [
      { id: 'car', label: 'Cars', price: 80 },
      { id: 'suv', label: 'SUV / D-Cabs', price: 90 },
      { id: 'kombi', label: 'Kombi', price: 100 },
    ],
  },
  {
    id: 'mini-valet',
    name: 'Mini Valet',
    description: 'Wash, vac, dash wipe, windows',
    tiers: [
      { id: 'car', label: 'Cars', price: 150 },
      { id: 'suv', label: 'SUV / D-Cabs', price: 180 },
      { id: 'kombi', label: 'Kombi', price: 200 },
    ],
  },
  {
    id: 'full-valet',
    name: 'Full Valet',
    description: 'Full interior and exterior detail',
    tiers: [
      { id: 'car', label: 'Cars', price: 350 },
      { id: 'suv', label: 'SUV / D-Cabs', price: 420 },
      { id: 'kombi', label: 'Kombi', price: 480 },
    ],
  },
  {
    id: 'engine',
    name: 'Engine Clean',
    description: 'Engine bay clean and dress',
    tiers: [
      { id: 'car', label: 'Cars', price: 120 },
      { id: 'suv', label: 'SUV / D-Cabs', price: 140 },
      { id: 'kombi', label: 'Kombi', price: 160 },
    ],
  },
]

export const defaultPackageId = washPackages[0]?.id ?? ''

export function getPackageById(id) {
  return washPackages.find((p) => p.id === id) || null
}

export function getTier(packageDef, tierId) {
  if (!packageDef) return null
  return packageDef.tiers.find((t) => t.id === tierId) || packageDef.tiers[0] || null
}

export function formatWashSelectionLabel(packageDef, tier) {
  if (!packageDef || !tier) return ''
  return `${packageDef.name} - ${tier.label}`
}

/** Price on arrival — no fixed list price; amount captured at check-in / POS */
export function isTierPOA(tier) {
  return Boolean(tier?.poa)
}

export function formatTierPriceDisplay(tier) {
  if (!tier) return '—'
  if (isTierPOA(tier)) return 'POA'
  return `R${Number(tier.price || 0).toFixed(2)}`
}

/** Fixed catalog price, or staff-entered amount when tier is POA */
export function resolveTierAmount(tier, poaEnteredPrice) {
  if (!tier) return 0
  if (isTierPOA(tier)) {
    const n = Number(poaEnteredPrice)
    return Number.isFinite(n) && n > 0 ? n : 0
  }
  return Number(tier.price || 0)
}
